// AppManager (Core Runtime)
export {
    ensureModule,
    registerLazyModule,
    store
} from './store';

export {
    instantiateVueApp
} from './vue';

export {
    registerComponent,
    registerDirective,
    registerFilter,
    registerPlugin
} from './vueRegistry';

export {
    ensureFeature,
    isFeatureLoaded
} from './featureRegistry';
